import AttachmentDataProviderItem from 'owa-service/lib/contract/AttachmentDataProviderItem';
import AttachmentResultCode from 'owa-service/lib/contract/AttachmentResultCode';
import GetAttachmentDataProviderItemsResponse from 'owa-service/lib/contract/GetAttachmentDataProviderItemsResponse';
import { trace } from 'owa-trace';

export default function handleGetOrSearchFileProviderItemsResponse(
    response: GetAttachmentDataProviderItemsResponse,
    fileProviderId: string
): AttachmentDataProviderItem[] {
    if (response.ResultCode !== AttachmentResultCode.Success) {
        trace.warn(
            'FilePicker: updateFileProviderItems got non success result code for response ' +
                response.ResultCode
        );
        throw response.ResultCode;
    }

    response.Items.forEach(i => (i.AttachmentProviderId = fileProviderId));
    return response.Items;
}
